import React, { useState } from 'react';
import { ChevronDown } from 'lucide-react';
import { AccordionElement as AccordionType } from '../../types/element.types';

interface AccordionElementProps {
  element: AccordionType;
}

/**
 * Accordion Element Renderer
 * Collapsible content panels
 */
const AccordionElement: React.FC<AccordionElementProps> = ({ element }) => {
  const { items } = element.content || { items: [] };
  const { allowMultiple } = element.settings || {};
  const [openItems, setOpenItems] = useState<string[]>([]);

  const toggleItem = (itemId: string) => {
    if (allowMultiple) {
      setOpenItems((prev) =>
        prev.includes(itemId) ? prev.filter((id) => id !== itemId) : [...prev, itemId]
      );
    } else {
      setOpenItems((prev) => (prev.includes(itemId) ? [] : [itemId]));
    }
  };

  return (
    <div
      className="accordion-element"
      style={element.styles as React.CSSProperties}
    >
      {items.map((item) => {
        const isOpen = openItems.includes(item.id);
        return (
          <div key={item.id} className="border-b border-gray-200 last:border-b-0">
            <button
              onClick={() => toggleItem(item.id)}
              className="w-full flex items-center justify-between p-4 text-left hover:bg-gray-50 transition-colors"
            >
              <span className="font-medium">{item.title}</span>
              <ChevronDown
                size={20}
                className={`transition-transform ${isOpen ? 'rotate-180' : ''}`}
              />
            </button>
            {isOpen && (
              <div className="p-4 pt-0 text-gray-600">
                {item.content}
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
};

export default AccordionElement;

